import styled from '@emotion/styled'
import IconButton from '@mui/material/IconButton'
import { theme } from 'styles/theme/hav-theme'

export const TOPBAR_HEIGHT = '52px'

export const Topbar = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: ${TOPBAR_HEIGHT};
  background-color: ${theme.colors.support.red};
  max-width: unset;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${theme.spacing.xl};
  z-index: 1500;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.xs};
`

export const NotificationsButtonWrapper = styled.div`
  width: ${theme.spacing.xl};
  height: ${theme.spacing.xl};
`

export const NotificationNumberStyled = styled.div`
  background-color: ${theme.colors.neutral.white};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  top: -38px;
  left: 21px;
  font-size: ${theme.typography.sizes['2xs']};
  font-family: ${theme.typography.family.bold};
  color: ${theme.colors.support.red};
  border-radius: ${theme.shapes.borderRadius.full};
  border: 2px solid ${theme.colors.support.red};
  height: 20px;
  width: 20px;
`

export const IconButtonStyled = styled(IconButton)`
  color: inherit;
  display: flex;
  padding: 0;
  width: ${theme.spacing.xl};
  height: ${theme.spacing.xl};
  background-color: ${theme.colors.support.red};
  :hover {
    background-color: ${theme.colors.support.redhover};
  }
  border-radius: ${theme.shapes.borderRadius.sm};
`

export const SupportLink = styled.a`
  cursor: pointer;
  color: ${theme.colors.primary.main};
  font-family: ${theme.typography.family.bold};
  text-decoration: underline;
`
